import styles from "./StaleWarning.module.scss";

export const StaleWarning = () => {
  return (
    <div className={styles["container"]}>
      <p className={styles["message"]}>
        依存先のドキュメントが更新されています。最新の内容を反映するには生成してください。
      </p>
    </div>
  );
};
